import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { siteSettingsStore, applyThemeColors, applyThemeFont, applyThemeFontScale } from './store/siteSettingsStore'

// Apply saved theme colors, font & scale on startup
siteSettingsStore.get().then((s) => {
  applyThemeColors(s.primaryColor, s.secondaryColor);
  applyThemeFont(s.fontFamily || 'Cairo');
  applyThemeFontScale(s.fontScale ?? 1.0);
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
